import * as React from 'react';
import { ReactNode } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import { IntlShape, useIntl } from 'react-intl';

export const Loading = (): ReactNode => {
  const intl: IntlShape = useIntl();
  return <div className={'flex flex-column w-full h-full justify-content-center align-items-center'}>
    <ProgressSpinner/>
    <h3>{intl.formatMessage({id: 'core.loading'})}</h3>
  </div>;
};
